"use client";

import { c as _c } from "react/compiler-runtime";
import { App } from "@capacitor/app";
import { Capacitor, PluginListenerHandle } from "@capacitor/core";
import { Keyboard } from "@capacitor/keyboard";
import { useEffect, useState } from "react";
enum CapacitorOrientationType {
  PORTRAIT,
  LANDSCAPE,
}
const useCapacitor = () => {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = Capacitor.isNativePlatform();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isCapacitor = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = Capacitor.getPlatform();
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const platform = t1;
  const isIos = platform === "ios";
  const isAndroid = platform === "android";
  const [isActive, setIsActive] = useState(false);
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      if (!isCapacitor) {
        setIsActive(false);
        return;
      } else {
        App.getState().then(state => {
          setIsActive(state.isActive);
        });
      }
      const appStateListener = App.addListener("appStateChange", state_0 => {
        setIsActive(state_0.isActive);
      });
      return () => {
        appStateListener.then(_temp);
      };
    };
    t3 = [isCapacitor];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  const [orientation, setOrientation] = useState(CapacitorOrientationType.PORTRAIT);
  const [keyboardVisible, setKeyboardVisible] = useState(false);
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      if (!isCapacitor) {
        return;
      }
      const isPortrait = _temp2;
      const handleOrientationChange = () => {
        setOrientation(isPortrait() ? CapacitorOrientationType.PORTRAIT : CapacitorOrientationType.LANDSCAPE);
      };
      handleOrientationChange();
      window.addEventListener("orientationchange", handleOrientationChange);
      return () => {
        window.removeEventListener("orientationchange", handleOrientationChange);
      };
    };
    t5 = [isCapacitor];
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      if (!isCapacitor) {
        return;
      }
      let keyboardShowListener;
      let keyboardHideListener;
      const addKeyboardListeners = async () => {
        if (isIos) {
          ;
          try {
            await Keyboard.setAccessoryBarVisible({
              isVisible: true
            });
            keyboardShowListener = await Keyboard.addListener("keyboardWillShow", () => {
              setKeyboardVisible(true);
            });
            keyboardHideListener = await Keyboard.addListener("keyboardWillHide", () => {
              setKeyboardVisible(false);
            });
          } catch (t8) {
            const error = t8;
            console.error("Keyboard plugin error:", error);
          }
        }
      };
      addKeyboardListeners();
      return () => {
        keyboardShowListener?.remove();
        keyboardHideListener?.remove();
      };
    };
    t7 = [isCapacitor];
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  useEffect(t6, t7);
  let t8;
  if ($[8] !== isActive || $[9] !== keyboardVisible || $[10] !== orientation) {
    t8 = {
      isCapacitor,
      platform,
      isIos,
      isAndroid,
      orientation,
      keyboardVisible,
      isActive
    };
    $[8] = isActive;
    $[9] = keyboardVisible;
    $[10] = orientation;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
};
export default useCapacitor;
function _temp(listener) {
  return listener.remove();
}
function _temp2() {
  return window.matchMedia("(orientation: portrait)").matches;
}